import React, { useEffect } from "react"
import { Link, graphql } from "gatsby"
import { useTranslation } from 'react-i18next';

import Layout from "../components/layout"
import Seo from "../components/seo"

const BlogPostTemplate = ({ data, location }) => {
  const post = data.markdownRemark
  const { previous, next } = data
  const language = post.frontmatter.language
  const dateStr = post.frontmatter.date.split(';')[language === "en" ? 0 : 1]
  const { i18n } = useTranslation();
  const t = i18n.getFixedT(language, 'common');

  useEffect(() => {
    if (i18n.language !== language) i18n.changeLanguage(language)
  }, [language, i18n.language, i18n])

  const siteTitle = t('common:title')

  const emojiForMin = (min) => min <= 5 ? "📄" : min <= 10 ? "📰" : "📚"
  const minToReadMsg = (min) => (<>
      <b>{`${min}`}</b>{' '}
      {t('common:minToRead', {mins: `min` + (min >= 2 ? 's' : ''), emoji: emojiForMin(min)})}
    </>
  );

  return (
    <Layout location={location} title={siteTitle}>
      <Seo
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
        lang={language}
      />
      <article
        className="blog-post"
        itemScope
        itemType="http://schema.org/Article"
      >
        <header>
          <h1 itemProp="headline">{post.frontmatter.title}</h1>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <p>{dateStr}</p>
            {language === 'en' && <small>{minToReadMsg(post.timeToRead)}</small>}
          </div>
        </header>
        <section
          dangerouslySetInnerHTML={{ __html: post.html }}
          itemProp="articleBody"
        />
        <hr />
        <footer>
          <p>{t('common:postFooter')}</p>
          <nav>
            <ul style={{display:'inline'}}>
              <li style={{display:'inline'}}>
              <a href={`https://twitter.com/takkyuO2`}>
                twitter
              </a>
              </li>
              {` `}
              <li style={{display:'inline'}}>
              <a href={`https://github.com/takkyu2`}>
                github
              </a>
              </li>
            </ul>
          </nav>
        </footer>
      </article>
      <nav className="blog-post-nav">
        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {previous && (
              <Link to={previous.fields.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            )}
          </li>
        </ul>
      </nav>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString:  "MMMM DD, YYYY;YYYY年MM月DD日")
        description
        language
      }
      timeToRead
    }
    previous: markdownRemark(id: { eq: $previousPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
    next: markdownRemark(id: { eq: $nextPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
  }
`
